import { httpClient } from '@/services/http/httpClient'

type DeleteTaskCommentProps = {
  id: string
  projectId: string
}

export async function deleteTaskComment({
  id,
  projectId,
}: DeleteTaskCommentProps) {
  await httpClient.delete(`/projects/task-comments/${projectId}/${id}`)
}
